export default __webpack_public_path__ + "static/media/a017-5.7ff8f002.svg";